import { Label } from "@/shared/components/ui/label";
import { InputErrorMessages } from "@/shared/components/errors/input-error-messages";
import { cn } from "@/shared/lib/utils";
import { Textarea } from "@/shared/components/ui/textarea";

interface TextareaInputProps {
  label: string;
  field: string;
  text: string;
  onTextChange: (text: string) => void;
  errors: string[] | null;
  hint?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  textareaClassName?: string;
}

/**
 * @deprecated Use {@link ../field/textarea-field.tsx}
 */
export function TextareaInput({
  label,
  field,
  text,
  onTextChange,
  errors,
  hint,
  placeholder,
  disabled,
  className,
  textareaClassName,
}: TextareaInputProps) {
  return (
    <div className={cn("grid content-start gap-1.5", className)}>
      <Label htmlFor={field}>{label}</Label>
      <Textarea
        id={field}
        value={text}
        onChange={(e) => onTextChange(e.target.value)}
        className={cn(
          errors && errors.length > 0 ? "border-red-500 shadow-md" : "",
          textareaClassName,
        )}
        placeholder={placeholder}
        disabled={disabled}
      />
      <span className="text-muted-foreground text-sm" hidden={!hint}>
        {hint}
      </span>
      <InputErrorMessages errors={errors ?? []} />
    </div>
  );
}
